import { callDelete } from "./base";

const UNREAD_URL = '/api/messaging/unread_messages'

function clearRecentMessages() {
  return callDelete(`${UNREAD_URL}`)
}

export default clearRecentMessages